import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Box, Icon } from "../../../../common/components";
import { TextGradientStyles } from "../../../../styles/theme";
import { Typography } from "@mui/material";

const CartItemPreviewCustomLabel = () => {
  const { t } = useTranslation();

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      gap={"2px"}
      sx={{ "& *": TextGradientStyles }}
    >
      <Icon icon="script" size={12} weight={600} />
      <Typography variant="textSmBold">
        {t("studio.custom_label.title")}
      </Typography>
    </Box>
  );
};

export default memo(CartItemPreviewCustomLabel);
